export default class EventBus<CustomTargetConfig extends Record<string, unknown>> {
    // for now, not marking this as private,
    // because it makes Vue types a mess for AdMediator/AdMediatorVueInstance. See:
    // https://github.com/vuejs/language-tools/issues/1857 and https://github.com/vuejs/core/issues/2981#issuecomment-1831724017
    readonly bus

    constructor() {
        this.bus = new EventTarget()
    }

    dispatch<Ev extends keyof CustomTargetConfig>(eventName: Ev, payload: CustomTargetConfig[Ev]) {
        this.bus.dispatchEvent(new CustomEvent(eventName as string, { detail: payload }))
    }

    addEventListener<Ev extends keyof CustomTargetConfig>(
        eventName: Ev,
        callback: (payload: CustomEvent<CustomTargetConfig[Ev]>) => void,
    ) {
        this.bus.addEventListener(eventName as string, (event) => {
            callback(event as CustomEvent<CustomTargetConfig[Ev]>) // typed callback
        })
    }

    removeEventListener<Ev extends keyof CustomTargetConfig>(
        eventName: Ev,
        callback: (payload: CustomEvent<CustomTargetConfig[Ev]>) => void,
    ) {
        this.bus.removeEventListener(eventName as string, (event) => {
            callback(event as CustomEvent<CustomTargetConfig[Ev]>) // typed callback
        })
    }
}
